import { ROUTES } from 'constants/routes';
import { useSection } from 'hooks/section';
import { useDispatch, useSelector } from 'hooks/store';
import React from 'react';
import { useHistory } from 'react-router';
import { logoutAction, sessionIsLoadingSelector, userProfileSelector } from 'state/slices/session';

import {
  Logo,
  Icons,
} from 'UI';

import {
  MenuItem,
  UserMenu,
  OrganizationSelector,
} from './components';

import {
  MainContainer,
  LogoContainer,
  StyledAntdMenu,
  UserMenuContainer,
} from './style';

const SideMenu = (): JSX.Element => {
  const section = useSection();
  const history = useHistory();
  const userProfile = useSelector(userProfileSelector);
  const isSessionLoading = useSelector(sessionIsLoadingSelector);
  const dispatch = useDispatch();
  const logout = () => {
    dispatch(logoutAction());
  };
  const curSection = section || '';

  return (
    <MainContainer>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <StyledAntdMenu
        onClick={(props) => {
          history.push(props.key as string);
        }}
        selectedKeys={[curSection]}
      >
        <MenuItem key={ROUTES.dashboard.root} icon={<Icons.Dashboard />}>
          Painel
        </MenuItem>
        <MenuItem key={ROUTES.orders.root} icon={<Icons.Order />}>
          Pedidos
        </MenuItem>
        <MenuItem key={ROUTES.seeding.root} icon={<Icons.Seed />}>
          Semeio
        </MenuItem>
        <MenuItem key={ROUTES.development.root} icon={<Icons.Development />}>
          Desenvolvimento
        </MenuItem>
        <MenuItem key={ROUTES.transport.root} icon={<Icons.Transport />}>
          Entrega
        </MenuItem>
      </StyledAntdMenu>
      <UserMenuContainer>
        <OrganizationSelector />
        <UserMenu user={userProfile} logout={logout} isLoading={isSessionLoading} />
      </UserMenuContainer>
    </MainContainer>
  );
};

export default SideMenu;
